module.exports = __webpack_public_path__ + "static/media/theater.4e0e941a.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Sizilien/theater.JPG
// module id = 777
// module chunks = 0